(function () {

  const modal = document.getElementById('wholesaleDrawer');
  const openBtns = document.querySelectorAll('.openWholesaleDrawer');
  const closeBtn = document.getElementById('closeWholesaleDrawer');
  const form = document.getElementById('wholesale-contact-form');

  if (!modal || !openBtns.length || !closeBtn) return;

  // ── Focus trap ──────────────────────────────────────────────────

  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  function getFocusable() {
    return Array.from(modal.querySelectorAll(FOCUSABLE)).filter(
      el => !el.closest('[hidden]')
    );
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusable = getFocusable();
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // ── Open / close ────────────────────────────────────────────────

  let previousFocus = null;

  function openModal() {
    previousFocus = document.activeElement;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    modal.removeAttribute('aria-hidden');
    requestAnimationFrame(() => {
      const focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    });
    modal.addEventListener('keydown', trapFocus);
    document.addEventListener('keydown', handleEsc);
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    modal.setAttribute('aria-hidden', 'true');
    modal.removeEventListener('keydown', trapFocus);
    document.removeEventListener('keydown', handleEsc);
    if (previousFocus) previousFocus.focus();
  }

  function handleEsc(e) {
    if (e.key === 'Escape') closeModal();
  }

  // ── Listeners ───────────────────────────────────────────────────

  openBtns.forEach(btn => btn.addEventListener('click', openModal));
  closeBtn.addEventListener('click', closeModal);

  // Close when clicking the backdrop (outside the inner box)
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  // ── Serialize checkboxes before submit ──────────────────────────

  if (form) {
    form.addEventListener('submit', function () {
      ['Equipment Needs', 'Food & Beverage Positions', 'Coffee Positions'].forEach(function (groupName) {
        const checkboxes = form.querySelectorAll(
          'input[type="checkbox"][name="contact[' + groupName + ']"]:checked'
        );
        if (checkboxes.length) {
          checkboxes.forEach(cb => cb.disabled = true);
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'contact[' + groupName + ']';
          hidden.value = Array.from(checkboxes).map(cb => cb.value).join(', ');
          form.appendChild(hidden);
        }
      });
    });
  }

})();